import { AppBarModuleAndPinningTuiGroup, AppsModuleTuiItem, AppsModuleWithPrivacyTuiItem, NewUserAllSetTuiItem, NewUserUploadTuiItem, } from '../shared';
import { AppPinningWizardTuiItem } from '../shared/apps-module-sequence';
import { AddContentTuiItem, AdminAcquiredAppsTuiItem, CommercialNewUserCreateTuiItem, CommercialNewUserMyContentTuiItem, FeedModuleTuiItem, NewUserInstallTuiItem, VisioLibraryTileTuiItem, } from './tui-items';
export var CommercialTuiConfig = {
    newUserTuiSequence: [
        CommercialNewUserCreateTuiItem,
        CommercialNewUserMyContentTuiItem,
        AppsModuleTuiItem,
        AppsModuleWithPrivacyTuiItem,
        NewUserUploadTuiItem,
        NewUserInstallTuiItem,
        NewUserAllSetTuiItem,
    ],
    returningUserTuiSequence: [
        FeedModuleTuiItem,
        // TODO: Once Pinning Wizard is 100% in commercial, remove the AppBarModuleAndPinningTuiGroup from commercial as it will be completely replaced.
        AppBarModuleAndPinningTuiGroup,
        AddContentTuiItem,
    ],
    standaloneTuiItems: [
        AdminAcquiredAppsTuiItem,
        AppPinningWizardTuiItem,
        VisioLibraryTileTuiItem,
    ],
};
//# sourceMappingURL=config.js.map